import { spacer24, Text, spacer40, cssColorValue, spacer16, spacer8, spacer12, spacer32, } from '@spotify-internal/encore-web/core';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useActiveSubmenuContext } from '../../../../../ActiveSubmenu/ActiveSubmenuProvider';
import { TextLink } from '../../../../../LinkV2';
import { trackCat } from '../../../../constants';
import { DELAYS, fadeInAnimation } from '../../../../fadeInAnimation';
import { TWO_COLUMN_MAX_WIDTH, ONE_COLUMN_MAX_WIDTH } from '../../Grid';
import { useGalleryMenuContext } from '../GalleryMenuProvider';
import { MobileGalleryLink } from '../MobileGalleryLink';
const sanitizeEyebrow = (eyebrow) => {
    const LENGTH_LIMIT = 25;
    if (eyebrow.length > LENGTH_LIMIT) {
        console.error(`GalleryLinkList: eyebrow exceeded maximum threshold of ${LENGTH_LIMIT}`);
    }
    return eyebrow.substring(0, LENGTH_LIMIT);
};
const sanitizeGalleryLinks = (galleryLinks, size) => {
    const ITEM_LIMIT = size === 'large' ? 4 : 7;
    const LINK_LENGTH_LIMIT = size === 'large' ? 10 : 20;
    if (galleryLinks.length > ITEM_LIMIT) {
        console.error(`GalleryLinkList: galleryLinks exceeded maximum threshold of ${ITEM_LIMIT}`);
    }
    return galleryLinks
        .filter((_, i) => i < ITEM_LIMIT)
        .map(link => {
        if (link.link.label.length > LINK_LENGTH_LIMIT) {
            console.error(`GalleryLinkList: link label exceeded maximum threshold of ${LINK_LENGTH_LIMIT}`);
        }
        return Object.assign(Object.assign({}, link), { link: Object.assign(Object.assign({}, link.link), { label: link.link.label.substring(0, LINK_LENGTH_LIMIT) }) });
    });
};
const GalleryLinkListSection = styled.section.withConfig({
    shouldForwardProp: prop => !['delay', 'size'].includes(prop),
}) `
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    ${({ delay }) => delay && fadeInAnimation(delay)}
  }

  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    .desktop {
      display: none;
    }
    .mobile {
      display: grid !important;
      @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: ${spacer24};
        grid-row-gap: ${spacer40};
        grid-template-rows: unset;
      }
      @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
        grid-template-columns: repeat(1, 1fr);
        column-gap: 0px;
        grid-row-gap: ${({ size }) => (size === 'large' ? spacer16 : spacer32)};
        grid-template-rows: unset;
        flex-direction: column;
      }
      list-style: none;
      padding: 0;
      margin: 0;
      margin-top: ${spacer24};
      li {
        margin-bottom: 0;
      }
    }
  }
  & nav {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: ${spacer24};
    & li {
      margin-bottom: ${({ size }) => (size === 'large' ? spacer16 : spacer8)};
      @media (min-width: 1440px) {
        margin-bottom: ${({ size }) => size === 'large' ? spacer16 : spacer12};
      }
    }
    & li:last-of-type {
      margin-bottom: 0;
    }
  }
`;
const EyebrowLabel = styled(Text).attrs({
    variant: 'bodyMedium',
    semanticColor: 'textSubdued',
}) ``;
export const GalleryLinkList = ({ eyebrow, onNavigate = () => { }, links, size, useIconOnMobile = false, delay, }) => {
    const { activeGalleryLink, setActiveGalleryLink } = useGalleryMenuContext();
    const { clearActiveSubmenu } = useActiveSubmenuContext();
    const sanitizedLinks = sanitizeGalleryLinks(links, size);
    const sanitizedEyebrow = sanitizeEyebrow(eyebrow);
    const onClick = useCallback((x) => {
        onNavigate();
        clearActiveSubmenu(x);
    }, [clearActiveSubmenu, onNavigate]);
    return (React.createElement(GalleryLinkListSection, { size: size, delay: delay },
        React.createElement(EyebrowLabel, { className: "eyebrow" }, sanitizedEyebrow),
        React.createElement("nav", { className: "desktop" }, sanitizedLinks.map((galleryLink, index) => (React.createElement("li", { key: index + 1 },
            React.createElement(TextLink, Object.assign({}, galleryLink.link, { size: size || 'small', trackingCategory: trackCat, svgIcon: undefined, color: (activeGalleryLink === null || activeGalleryLink === void 0 ? void 0 : activeGalleryLink.link.id) === (galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.link.id)
                    ? cssColorValue('textBase')
                    : cssColorValue('textSubdued'), onClick: onClick, onHover: () => setActiveGalleryLink(galleryLink) })))))),
        React.createElement("nav", { className: "mobile" }, sanitizedLinks.map((galleryLink, index) => (React.createElement("li", { key: index + 1 }, size === 'large' ? (React.createElement(TextLink, Object.assign({}, galleryLink.link, { size: size || 'small', trackingCategory: trackCat, onClick: onClick, svgIcon: useIconOnMobile ? galleryLink.mobileNavIcon : undefined }))) : (React.createElement(MobileGalleryLink, { image: galleryLink.image, description: galleryLink.description || '', link: galleryLink.link, trackingCategory: trackCat, delay: DELAYS[index + 1] }))))))));
};
//# sourceMappingURL=index.js.map